import { makeStyles } from "@material-ui/core/styles";
// import theme from "theme";

const useStyles = makeStyles({
  title: {
    font: "normal normal bold 30px/34px Arial",
    color: "#393A42",
    marginBottom: 40,
  },
  waterUserCard: {
    position: "relative",
    width: "100%",
    minHeight: 100,
    borderRadius: 5,
    height: 660,
    "&::before": {
      content: '""',
      display: "block",
      position: "absolute",
      width: "100%",
      height: "100%",
      maxHeight: 250,
      top: 0,
      left: 0,
      background:
        "transparent linear-gradient(180deg, #6F7FA300 0%, #8096C6 100%) 0% 0% no-repeat padding-box",
      transform: "matrix(-1, 0, 0, -1, 0, 0)",
      mixBlendMode: "multiply",
      borderRadius: 5,
      transition: "max-height 150ms ease-in-out",
    },
    "&:hover": {
      cursor: "pointer",
      "& $waterUserDesc": {
        display: "block",
      },
      "& $waterUserExploreBtn": {
        display: "block",
      },
    },
    "&:hover:before": {
      maxHeight: "100%",
      background: "rgba(5, 46, 155, 0.65)",
    },
  },
  waterUserDesc: {
    color: "#FFFFFF",
    font: "normal normal normal 13px/19px Arial",
    padding: 20,
    fontSize: 13,
    position: "relative",
    opacity: 1,
    display: "none",
  },
  waterUserExploreBtn: {
    borderRadius: 15,
    textTransform: "uppercase",
    fontSize: 10,
    background: "#FFFFFF",
    marginLeft: `calc(50% - 40px)`,
    display: "none",
  },
  waterUserCardTitle: {
    color: "#FFFFFF",
    font: "normal normal bold 37px/42px Arial",
    paddingTop: 35,
    paddingLeft: 20,
    paddingRight: 20,
    position: "relative",
    opacity: 1,
  },
  waterUserOverlay: {
    width: "100%",
    height: "100%",
  },
  chart: {
    paddingLeft: 54,
    paddingRight: 54
  },
  industryRadioGroup: {
    paddingLeft: 64,
    // paddingTop: 25,
    paddingBottom: 20,
  },
  industryRadio: {
    color: "#2352D0",
    "& $checked": {
      color: "#2352D0"
    }
  },
  chartContainer: {
    paddingLeft: 64,
    // paddingRight: 54,
    // height: "60vh",
    // display: "flex",
    justifyContent: "center",
    marginTop: "25px",
    alignItems: "start",
  },
}, { index: 999 });

export default useStyles;
